module.exports = __webpack_public_path__ + "static/abstract_3-b7186df7f24d234d2ee8a85c07daee54.jpg";